<template lang="html">
<section>
  <div class="hero-slider swiper-container">
    <div class="swiper-wrapper">
      <div v-for="slide in slides" class="swiper-slide">
        <component :is="slide"></component>
      </div>
    </div>
    <div class="swiper-button-prev swiper-button-white"></div>
    <div class="swiper-button-next swiper-button-white"></div>
  </div>
</section>

</template>
<script>
import iMatter1 from './iMatter1.vue'
import iMatter2 from './iMatter2.vue'
import HighSchoolOpenHouse from './HighSchoolOpenHouse2024.vue'

const slides = {
  HighSchoolOpenHouse,iMatter1,iMatter2
}

export default {
  name: 'LLC',
  components: slides,
  data() {
    return { slides }
  }
}
</script>

<style lang="less">
@import '../_base/styles/variables.less';
@import "../../node_modules/swiper/dist/css/swiper.css";

.swiper-button-white {
  background: rgba(0,0,0,0.4);
  transition: ease all 400ms;
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  width: 37px;
  height: 50px;
  &:hover {
    transform:scale(1.1);
  }
}
.swiper-button-prev {
	left: 0px;
  @media (min-width: 1500px) {
		left: 10px;
  }
}
.swiper-button-next {
	right: 0px;
  @media (min-width: 1500px) {
		right: 10px;
  }
}
.hero {
  z-index: 1;
  position: relative;
  overflow: hidden;
  min-height: 500px;
  max-height: 650px;
  height: 90vh;


  a.outline-button {
    font-size: 1.5em;
    line-height: 1.2;
    color: white;
    display: inline-block;
    padding: 0.25em 0.5em;
    border: 1px solid white;
  }

  @media (min-width: @nav-width-break) {
    min-height: 600px;
    max-height: 850px;
  }

  &:before {
    content: "";
    background: black;
    width: 100%;
    height: 200px;
    position: absolute;
    background: rgba(0,0,0,0.4);
    /* For browsers that do not support gradients */
    background: -webkit-linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0));
    /* For Safari 5.1 to 6.0 */
    background: -o-linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0));
    /* For Opera 11.1 to 12.0 */
    background: -moz-linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0));
    /* For Firefox 3.6 to 15 */
    background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0));
    /* Standard syntax */
    z-index: 2;
		left: 0;
  }

  .background {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    img {
      min-width: 100%;
      min-height: 100%;
      max-width: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .content {
    z-index: 3;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;

    .w-m-50 {
      @media (min-width: @nav-width-break) {
        width: 50%;
      }
    }

    &.content-bottom {
      align-items: flex-end;
      bottom: 15%;
    }

    &.content-centered {
      text-align: center;

      h1 {
        margin-left: auto;
        margin-right: auto;
      }
    }

    &.content-right {
      text-align: right;

      h1 {
        margin-left: auto;
      }
    }

    .container {
      color: #fff;
    }
  }

  h1,h2 {
    text-shadow: 0 0 18px rgba(0, 0, 0, 0.59);
    font-weight: bold;
    margin: 2rem 0;
  }
  h1 {
    font-family: @font-hero;
    color: #fff;
    font-size: 7rem;
  }
  h2 {
    font-size: 3rem;
  }

  .hero-button {
    background: #fff;
    color: #000;
    font-size: 1.2rem;
    box-shadow: 0 0 18px rgba(0, 0, 0, 0.59);
    padding: 0 20px;
    position: relative;
    height: 40px;
    line-height: 40px;
    @media (min-width: @nav-width-break) {
      margin-left: 40px;
    }

    .icon {
      position: absolute;
      left: -40px;
      border: 3px solid #fff;
      display: block;
      width: 40px;
      height: 34px;
      display: none;
      box-shadow: -10px 0  18px rgba(0, 0, 0, 0.3);
      @media (min-width: @nav-width-break) {
        display: block;
      }

      .arrow-right {
        position: absolute;
        top: 8px;
        left: 18px;
        border-left-color: #fff;

        &:before {
          border-top-color: #fff;
        }
      }
    }

    &:hover {
      background: @color-brand;
      color: #fff;

      .icon {
        border-color: @color-brand;
      }
    }
  }
}

/* animation delays*/

.delay-500 {
  transition-delay: 500ms;
}
.delay-1000 {
  transition-delay: 1000ms;
}
.delay-1500 {
  transition-delay: 1500ms;
}
.delay-2000 {
  transition-delay: 3000ms;
}
.delay-3000 {
  transition-delay: 4000ms;
}
.delay-4000 {
  transition-delay: 58000ms;
}
</style>



// WEBPACK FOOTER //
// theme/bananar/LLC.vue